import React from 'react';

type Props = {
  width: number;
  height: number;
  fill?: string;
}

const ComboChartIcon = ({ width, height, fill }: Props) => (
  <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.6667 18.2V8.00002H14.6667V18.2L12.6667 16.3334L10.6667 18.2ZM17.3333 20.2V2.66669H21.3333V16.2L17.3333 20.2ZM4 24.8V13.3334H8V20.8L4 24.8ZM4 28.0667L12.6 19.4667L17.3333 23.5334L24.8 16.0667H22.6667V13.4H29.3333V20.0667H26.6667V17.9334L17.4667 27.1334L12.7333 23.0667L7.73333 28.0667H4Z"
      fill={fill}
      className="icon-fill"
    />
  </svg>
);

ComboChartIcon.defaultProps = {
  fill: 'var(--labelColor)',
};

export default ComboChartIcon;
